import React from 'react';
import { Route } from 'react-router';
import NewsManagement from './screens/NewsManagement/router';
import LatestNews from './screens/LatestNews/router';
export default (
  <Route
    path="companynews"
    getComponent={(location, cb) => {
      require.ensure([], (require) => {
        cb(null, require('./index'));
      });
    }}
  >
    {NewsManagement}
    {LatestNews}
  </Route>
);



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/screens/Tube/screens/CompanyNews/router.js
 **/